module.exports = __webpack_public_path__ + "img/id.9f708fe5.svg";